import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { getLanguageFromPath } from '../../utils/routes';

const content = {
  en: {
    title: 'Contact',
    intro: 'For questions, feedback, privacy requests, or business inquiries, you can contact the Tarkov Stash team by email.',
    emailLabel: 'Email',
    note: 'Please allow a reasonable amount of time for a response. This contact address is a placeholder for site support and legal requests.',
  },
  tr: {
    title: 'İletişim',
    intro: 'Sorular, geri bildirimler, gizlilik talepleri veya iş birlikleri için Tarkov Stash ekibine e-posta ile ulaşabilirsiniz.',
    emailLabel: 'E-posta',
    note: 'Yanıt için makul bir süre tanıyın. Bu iletişim adresi site desteği ve yasal talepler için kullanılan basit bir placeholder adrestir.',
  },
};

function Contact() {
  const { language } = useLanguage();
  const location = useLocation();
  const lang = (getLanguageFromPath(location.pathname) || language) === 'tr' ? 'tr' : 'en';
  const copy = content[lang];

  return (
    <main className="max-w-4xl mx-auto px-6 py-12 text-zinc-200">
      <h1 className="text-3xl md:text-4xl font-black text-white mb-6">{copy.title}</h1>
      <p className="text-zinc-400 leading-8 mb-8">{copy.intro}</p>
      <section className="rounded-lg border border-zinc-800 bg-black/30 p-6 shadow-md">
        <h2 className="text-sm font-bold uppercase tracking-widest text-zinc-500 mb-2">{copy.emailLabel}</h2>
        <a href="mailto:contact@tarkovstash.com" className="text-lg font-bold text-emerald-400 hover:text-emerald-300">
          contact@tarkovstash.com
        </a>
        <p className="text-xs leading-6 text-zinc-500 mt-5">{copy.note}</p>
      </section>
    </main>
  );
}

export default Contact;
